"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/switchMap");
require("rxjs/add/operator/filter");
var utils_1 = require("../../utils");
var webSocketHandler_1 = require("../../webSocketHandler");
var stompProtocol_1 = require("./stompProtocol");
var heartbeat_1 = require("../../heartbeat");
var parseHeartbeatSettings = function (heartbeat) {
    return [heartbeat.heartbeatSettings.outgoing, heartbeat.heartbeatSettings.incoming].join(',');
};
// STOMP Handler Class
//
// Using stompProtocol
//
var stompWebSocketHandler = function (createWsConnection, options) {
    var wsHandler = new webSocketHandler_1.default(createWsConnection, options);
    // creating the heartbeat
    var heartbeat = new heartbeat_1.default(options.heartbeat);
    var initConnection = function (headers) {
        var disconnectFn;
        var currentHeaders = __assign({}, headers);
        // Check if we already have heart-beat in headers before adding them
        if (!headers['heart-beat']) {
            currentHeaders['heart-beat'] = parseHeartbeatSettings(heartbeat);
        }
        return wsHandler.initConnection(currentHeaders).switchMap(function (wsConnection) {
            var counter = 0;
            var partialData = '';
            var version = '';
            var currentProtocol = stompProtocol_1.default(); // we initialise the current protocol with no version as we need it for CONNECT
            var _parseMessageReceived = function (evt) {
                var unmarshalledData = utils_1.parseData(evt.data, partialData, currentProtocol.hearbeatMsg && currentProtocol.hearbeatMsg());
                if (!unmarshalledData) {
                    return;
                }
                partialData = unmarshalledData.partial;
                return unmarshalledData.frames;
            };
            var unSubscribe = function (_headers) {
                return wsConnection.messageSender.next(currentProtocol.unSubscribe(_headers));
            };
            return Observable_1.Observable.create(function (connectionObserver) {
                var stompMessageReceived = new Subject_1.Subject();
                var stompMessageReceipted = new Subject_1.Subject();
                var errorReceived = new Subject_1.Subject();
                var subscribeTo = function (destination, _headers) {
                    if (_headers === void 0) { _headers = {}; }
                    var id = _headers.id || 'sub-' + counter++;
                    var currentHeader = { destination: destination, ack: _headers.ack, id: id };
                    wsConnection.messageSender.next(currentProtocol.subscribe(currentHeader));
                    return stompMessageReceived.finally(function () { return unSubscribe({ id: id }); }).filter(function (frame) { return frame.headers.subscription === id; });
                };
                // subscribing to message received
                var msgSubscription = wsConnection.messageReceived.subscribe(function (evt) {
                    heartbeat.activityFromServer();
                    var dataFrames = _parseMessageReceived(evt);
                    dataFrames && dataFrames.forEach(function (frame) {
                        switch (frame.command) {
                            case 'CONNECTED':
                                version = frame.headers.version;
                                currentProtocol = stompProtocol_1.default(version);
                                utils_1.logger.debug("connected to server " + frame.headers.server);
                                // we start heartbeat only if the protocol support it
                                var hearbeatMsg_1 = currentProtocol.hearbeatMsg();
                                if (hearbeatMsg_1) {
                                    var _a = (frame.headers['heart-beat'] || '0,0').split(',').map(function (v) { return parseInt(v, 10); }), serverOutgoing = _a[0], serverIncoming = _a[1];
                                    heartbeat.startHeartbeat(serverOutgoing, serverIncoming, {
                                        sendPing: function () { return wsConnection.messageSender.next(hearbeatMsg_1); },
                                        close: function (error) { return connectionObserver.error(error); }
                                    });
                                }
                                connectionObserver.next({
                                    subscribeTo: subscribeTo,
                                    messageReceipted: stompMessageReceipted.asObservable(),
                                    errorReceived: errorReceived.asObservable(),
                                    messageSender: wsConnection.messageSender,
                                    protocol: currentProtocol
                                });
                                break;
                            case 'MESSAGE':
                                var subscription_1 = currentProtocol.getSubscription(frame);
                                var messageID_1 = currentProtocol.getMessageId(frame);
                                frame.ack = function () { return wsConnection.messageSender.next(currentProtocol.ack(messageID_1, subscription_1)); };
                                currentProtocol.nack && (frame.nack = function () { return wsConnection.messageSender.next(currentProtocol.nack(messageID_1, subscription_1)); });
                                stompMessageReceived.next(frame);
                                break;
                            case 'RECEIPT':
                                stompMessageReceipted.next(frame);
                                break;
                            case 'ERROR':
                                errorReceived.next(frame);
                                break;
                            default:
                                utils_1.logger.debug("Unhandled frame: " + frame);
                        }
                    });
                });
                // sending connect
                wsConnection.messageSender.next(currentProtocol.connect(currentHeaders));
                disconnectFn = function () {
                    heartbeat.stopHeartbeat();
                    wsConnection.messageSender.next(currentProtocol.disconnect({ receipt: "" + counter++ }));
                };
                return function () {
                    msgSubscription && msgSubscription.unsubscribe();
                    stompMessageReceived.complete();
                    stompMessageReceipted.complete();
                    errorReceived.complete();
                };
            });
        }).finally(function () {
            disconnectFn && disconnectFn();
        });
    };
    return { initConnection: initConnection };
};
exports.default = stompWebSocketHandler;
